import React, {  useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import Loading from 'react-simple-loading';
import logo from "../assets/images/logo.png";
import Files from 'react-files'


const UploadRecord = () => {

    const [isBtn, setIsBtn] = useState(false);
    const [medicalRecordFile, setMedicalRecordFile] = useState(null);
    const [inputError, setInputError] = useState(false);
   

    const [files, setFiles] = useState([])
    const handleChange = (newFiles) => {
   //   alert(files.length)
      if(files.length > 3){
        Swal.fire({ icon: "error", title: "Error: ", text: "Maximum 4 files are allowed." });
      }
      else{
       setFiles(prevFiles => [...prevFiles, ...newFiles])
      }
    }
 
    const handleFileRemove = (fileId) => {
       setFiles(prevFiles => prevFiles.filter(prevFile => prevFile.id !== fileId))
    }
 
    const handleClearFiles = () => {
       setFiles([])
    }

    const handleError = (error, file) => {
      Swal.fire({ icon: "error", title: "Error: "+error.code, text: error.message });
    }
 
   
    const addMedicalRecordFile = async () => {

        setInputError(false);

        if(files.length < 1 || !medicalRecordFile?.work_order_no  || !medicalRecordFile?.patient_dob || !/^\d{2}\/\d{2}\/\d{4}$/.test(medicalRecordFile?.patient_dob))
        {
            setInputError(true);
        }
        else{
            setIsBtn(true);

     

       const formData = new FormData()
       files.forEach((file) => {
          formData.append("medical_records", new Blob([file], { type: file.type }), file.name || 'file')
       })

       formData.append("work_order_no",medicalRecordFile?.work_order_no)
       formData.append("patient_dob",medicalRecordFile?.patient_dob)


     
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/add-facility-medical-record", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true
        }).then(function (response) {


            if (response?.data?.status) {

              setMedicalRecordFile({work_order_no:"",medical_record:"",patient_dob:""})
              setFiles([]);
              setIsBtn(true);
                Swal.fire({ icon: "success", title: "Medical Record", text: "Medical record uploaded successfully!" });
               


            } else {

                Swal.fire({ icon: "error", title: "Medical Record", text: response?.data?.message });

            }
            setIsBtn(false);
        }).catch(function (error) {
          
            Swal.fire({ icon: "error", title: "Medical Record", text: error?.message });
        });

    }

    }


    return (

        <div className="card card-medium" >
            <div className="card-header">
                <img src={logo} alt="MedRecAps" />
            </div>
            <div className="card-body">
                <form >

                    <h4 className="text-center my-4 text-primary " >UPLOAD MEDICAL RECORD</h4>
                   
        
             <div className="container">
                  
                      
                            <div className="row py-2 gx-3">

                            <div className="col-xl-12 col-lg-12 col-sm-12 mb-4">
                            <label htmlFor="work_order_no" className="lbl-sm">CASE #*: </label>
                            <input name="work_order_no" id="work_order_no" type="text" className="form-control"
                              value={medicalRecordFile?.work_order_no} placeholder="e.g. BT58944"
                              onChange={(e) =>
                                setMedicalRecordFile({ ...medicalRecordFile, work_order_no: e.target.value })
                              }
                              maxLength={10}
                            
                            />
                            {inputError &&
                              (!medicalRecordFile?.work_order_no ) && (
                                <span className="text-danger">Enter valid case #</span>
                              )}

                                </div>


                                

                            <div className="col-xl-12 col-lg-12 col-sm-12 mb-4">
                            <label htmlFor="patient_dob" className="lbl-sm">PATIENT DATE OF BIRTH*: MM/DD/YYYY</label>
                            <DatePicker name="patient_dob" id="patient_dob" type="text"
                              className="form-control" placeholder="e.g. MM/DD/YYYY" showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={medicalRecordFile?.patient_dob}
                              onChange={(e) => {
                                var dt = new Date(e);

                                const year = dt.getFullYear();
                                const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                const day = dt.getDate().toString().padStart(2, "0");

                                const formatted_date = month + '/' + day + '/' + year

                                setMedicalRecordFile({ ...medicalRecordFile, patient_dob: formatted_date })

                              }
                              }
                            />
                          {inputError &&
                              (!medicalRecordFile?.patient_dob || !/^\d{2}\/\d{2}\/\d{4}$/.test(medicalRecordFile?.patient_dob)) && (
                                <span className="text-danger">Enter valid date of birth</span>
                              )}

                                </div>


                                


                                <div className="col-xl-12 col-lg-12 col-sm-12 mb-4">

                                <label htmlFor="medical_record" className="lbl-sm" >SINGLE OR YOU CAN UPLOAD MULTIPLE RECORDS*: </label>
                                <div className="files">
                                <Files
          className="files-dropzone-list form-control"
            dragActiveClassName="files-dropzone-active"
        onChange={handleChange}
        accepts={['.pdf', 'pdf/*']}
        onError={handleError}
        multiple
        maxFiles={4}
        maxFileSize={10000000}
        minFileSize={0}
        clickable>
        Drop files here or click to upload
      </Files>

         {files.length > 0 && (
            <div className="files-list">
               <ul>
                  {files.map(file => (
                     <li key={file.id} className="files-list-item">
                        <div className="files-list-item-preview">
                           {file.preview.type === 'image'
                              ? <img className="files-list-item-preview-image" src={file.preview.url} />
                              : <div className="files-list-item-preview-extension">{file.extension}</div>}
                        </div>
                        <div className="files-list-item-content">
                           <div className="files-list-item-content-item files-list-item-content-item-1">{file.name}</div>
                           <div className="files-list-item-content-item files-list-item-content-item-2">{file.sizeReadable}</div>
                        </div>
                        <div
                           className="files-list-item-remove"
                           onClick={() => handleFileRemove(file.id)}
                        />
                     </li>
                  ))}
               </ul>
            </div>
         )}
      </div>

      {inputError &&
                              (files.length <1 ) && (
                                <span className="text-danger">Attach medical record</span>
                              )}
                


                                </div>


                                <div className="col-xl-12 col-lg-12 col-sm-12 text-center my-4">

<button type="button" onClick={addMedicalRecordFile}  className="btn btn-lg btn-success" disabled={isBtn}>
    {isBtn ? <Loading /> : 'Upload Medical Record'}
</button>

</div>



                            </div>

                        

                </div>
        </form>
        </div>
        </div>
    )

}
export default UploadRecord;